// Pure display helpers for golf to-par formatting. Shared between the
// matchup picker (GolfPicksMode) and the divisions sheet (App.jsx
// DivisionsMemberResultsSheet + StandingsPodium). Single source of
// truth so the two surfaces can't drift on sign/E/null conventions.

// Score-to-par formatter — negative shows with minus, zero shows "E",
// positive shows with plus. null/undefined → "—". Used wherever a
// to-par integer is rendered.
export function formatScoreToPar(score) {
  if (score == null) return '—'
  const n = Number(score)
  if (!Number.isFinite(n)) return '—'
  if (n === 0)  return 'E'
  if (n > 0)    return `+${n}`
  return String(n)
}
